"use strict";

module.exports = {
  Promise: typeof Promise !== 'undefined' ? Promise : null
};
//# sourceMappingURL=promise.js.map



//////////////////
// WEBPACK FOOTER
// ./~/exceljs/dist/es5/utils/promise.js
// module id = 101
// module chunks = 0